import styled from "styled-components";

export const Main = styled.div`
  min-width: 150px;
  padding: 0;
`;

export const Styled = styled.div`
  .action {
    position: relative;
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    margin-bottom: 11px;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 0.5px;
      background-color: rgb(220, 220, 220);
    }
  }

  .select {
    margin-bottom: 10px;
    h4 {
      width: 100px;
    }
  }

  .textInput {
    margin-bottom: 10px;
    h4 {
      width: 115px;
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .textarea {
      &:last-of-type {
        margin-top: 10px;
      }
      > div {
         height: 100px;
         min-height: 100px;
      }
   }
`;